/* eslint-disable import/prefer-default-export */
export const USER_TYPE = {
  superadmin: 1, organisationadmin: 2, organisationUser: 3,
};

export const USER_TYPE_LABELS = {
  [USER_TYPE.superadmin]: 'Super Admin',
  [USER_TYPE.organisationadmin]: 'Organisation Admin',
  [USER_TYPE.organisationUser]: 'Organisation User',
};